// extracted by mini-css-extract-plugin
export default {"headerLogo":"TopBarLogo_headerLogo__OrbD7","headerLogoImage":"TopBarLogo_headerLogoImage__TPa9c","headerLogoText":"TopBarLogo_headerLogoText__+nFeD"};